import { CardId, NationalityPeriod } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredFutureDate, requiredPastDate } from '@/utils/zodUtils';

const nonNegativeInteger = (t: GetTextIdTranslationType) =>
  z
    .number({ message: t('REQUIRED_FIELD') })
    .refine((value) => Number.isFinite(value) && Number.isInteger(value) && value >= 0, {
      message: t('REQUIRED_FIELD'),
    });

export const NieDataEuFormSchema = (t: GetTextIdTranslationType) =>
  z.object({
    nationalityPeriod: requiredEnum(NationalityPeriod, t),
    socialSecurityDate: requiredPastDate(t),
    numberOfWork: nonNegativeInteger(t),
  });

export const NieDataFormSchema = (t: GetTextIdTranslationType) =>
  NieDataEuFormSchema(t).extend({
    cardId: requiredEnum(CardId, t),
    expirationDateCard: requiredFutureDate(t),
  });

export type NieDataFormType = z.infer<ReturnType<typeof NieDataFormSchema>>;
